import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/arrow-left-eoi-request.svg'


const _hoisted_1 = { class: "layout-eoi" }
const _hoisted_2 = { class: "link-back container" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "wrapper flex container"
}
const _hoisted_5 = { class: "form-box" }
const _hoisted_6 = { class: "input-row" }
const _hoisted_7 = { class: "input-wr" }
const _hoisted_8 = { class: "input-wr" }
const _hoisted_9 = { class: "input-row" }
const _hoisted_10 = { class: "input-wr" }
const _hoisted_11 = { class: "input-wr" }
const _hoisted_12 = { class: "input-row" }
const _hoisted_13 = { class: "input-wr w-50" }
const _hoisted_14 = { class: "input-row" }
const _hoisted_15 = { class: "input-wr" }
const _hoisted_16 = { class: "input-row" }
const _hoisted_17 = { class: "input-wr" }
const _hoisted_18 = { class: "input-row" }
const _hoisted_19 = { class: "input-wr" }
const _hoisted_20 = { class: "agree" }
const _hoisted_21 = { class: "card-box" }
const _hoisted_22 = { class: "sticky" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["HeaderCustomer"], {
      estate: $setup.estate,
      hideAuthButtons: true
    }, null, 8, ["estate"]),
    ($setup.showPage)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("a", {
              class: "back",
              href: `/v2/estate/${$setup.estateId}`
            }, [...(_cache[13] || (_cache[13] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "EOI Request"
              }, null, -1),
              _createTextVNode("Join Waitlist", -1)
            ]))], 8, _hoisted_3)
          ]),
          ($setup.estate._id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("form", {
                    class: "eoi-form",
                    onSubmit: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"]))
                  }, [
                    _cache[29] || (_cache[29] = _createElementVNode("h1", { class: "section-title" }, "Buyer details", -1)),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label" }, "First Name", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.waitlistForm.buyerDetails.firstName) = $event)),
                          type: "text",
                          placeholder: "First Name",
                          class: _normalizeClass({ error: $setup.v$.buyerDetails.firstName.$error }),
                          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.v$.buyerDetails.firstName.$touch && $setup.v$.buyerDetails.firstName.$touch(...args)))
                        }, null, 34), [
                          [
                            _vModelText,
                            $setup.waitlistForm.buyerDetails.firstName,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "tips" }, "Make sure it matches the name on your ID", -1)),
                        _createElementVNode("div", {
                          class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyerDetails.firstName.$error }])
                        }, _toDisplayString($setup.v$.buyerDetails.firstName.$errors[0]?.$message), 3)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label" }, "Last Name", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.waitlistForm.buyerDetails.lastName) = $event)),
                          type: "text",
                          placeholder: "Last Name",
                          class: _normalizeClass({ error: $setup.v$.buyerDetails.lastName.$error }),
                          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.v$.buyerDetails.lastName.$touch && $setup.v$.buyerDetails.lastName.$touch(...args)))
                        }, null, 34), [
                          [
                            _vModelText,
                            $setup.waitlistForm.buyerDetails.lastName,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyerDetails.lastName.$error }])
                        }, _toDisplayString($setup.v$.buyerDetails.lastName.$errors[0]?.$message), 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "label" }, "Email", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.waitlistForm.buyerDetails.email) = $event)),
                          type: "email",
                          placeholder: "Email",
                          class: _normalizeClass({ error: $setup.v$.buyerDetails.email.$error }),
                          onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.v$.buyerDetails.email.$touch && $setup.v$.buyerDetails.email.$touch(...args)))
                        }, null, 34), [
                          [
                            _vModelText,
                            $setup.waitlistForm.buyerDetails.email,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyerDetails.email.$error }])
                        }, _toDisplayString($setup.v$.buyerDetails.email.$errors[0]?.$message), 3)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _cache[18] || (_cache[18] = _createElementVNode("label", { class: "label" }, "Phone Number", -1)),
                        _createVNode($setup["Cleave"], {
                          modelValue: $setup.waitlistForm.buyerDetails.phone,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.waitlistForm.buyerDetails.phone) = $event)),
                          modelModifiers: { trim: true },
                          placeholder: "0412 345 678",
                          options: $setup.phoneNumberOption($setup.waitlistForm.buyerDetails.phone),
                          class: _normalizeClass({ error: $setup.v$.buyerDetails.phone.$error }),
                          onBlur: $setup.v$.buyerDetails.phone.$touch
                        }, null, 8, ["modelValue", "options", "class", "onBlur"]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyerDetails.phone.$error }])
                        }, _toDisplayString($setup.v$.buyerDetails.phone.$errors[0]?.$message), 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[19] || (_cache[19] = _createElementVNode("label", { class: "label" }, "Postcode", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["input", { error: $setup.v$.buyerDetails.postcode.$error }]),
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.waitlistForm.buyerDetails.postcode) = $event)),
                          type: "text",
                          maxlength: "4",
                          placeholder: "e.g. 2000"
                        }, null, 2), [
                          [_vModelText, $setup.waitlistForm.buyerDetails.postcode]
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["error-box", { 'show-error-sign': $setup.v$.buyerDetails.postcode.$error }])
                        }, _toDisplayString($setup.v$.buyerDetails.postcode.$errors[0]?.$message), 3)
                      ])
                    ]),
                    _cache[30] || (_cache[30] = _createElementVNode("h1", { class: "section-title" }, "Lot preferences", -1)),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[20] || (_cache[20] = _createElementVNode("label", { class: "label-slider" }, "Lot size:", -1)),
                        _createVNode($setup["SliderLimited"], {
                          modelValue: $setup.lotSize,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.lotSize) = $event)),
                          minTitle: "Min size",
                          minValue: $setup.range?.size?.min,
                          maxTitle: "Max size",
                          maxValue: $setup.range?.size?.max,
                          position: "right",
                          units: "m²",
                          step: 10
                        }, null, 8, ["modelValue", "minValue", "maxValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[21] || (_cache[21] = _createElementVNode("label", { class: "label-slider" }, "Frontage (width):", -1)),
                        _createVNode($setup["SliderLimited"], {
                          modelValue: $setup.frontage,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.frontage) = $event)),
                          minTitle: "Min size",
                          minValue: $setup.range?.frontage?.min,
                          maxTitle: "Max size",
                          maxValue: $setup.range?.frontage?.max,
                          position: "right",
                          units: "m",
                          step: 1
                        }, null, 8, ["modelValue", "minValue", "maxValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[22] || (_cache[22] = _createElementVNode("label", { class: "label-slider" }, "Budget:", -1)),
                        _createVNode($setup["SliderLimited"], {
                          modelValue: $setup.budget,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.budget) = $event)),
                          minTitle: "Min price",
                          minValue: $setup.range?.budget?.min,
                          maxTitle: "Max price",
                          maxValue: $setup.range?.budget?.max,
                          position: "left",
                          units: "$",
                          step: 10000
                        }, null, 8, ["modelValue", "minValue", "maxValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[25] || (_cache[25] = _createTextVNode("By selecting", -1)),
                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "bold" }, " Agree and Submit,", -1)),
                      _cache[27] || (_cache[27] = _createTextVNode(" I agree to the LotTrackr ", -1)),
                      _createVNode(_component_router_link, {
                        class: "link",
                        to: { name: 'CustomerTerms' },
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                          _createTextVNode("Terms of Services", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[28] || (_cache[28] = _createTextVNode(" and ", -1)),
                      _createVNode(_component_router_link, {
                        class: "link",
                        to: { name: 'PrivacyPolicy' },
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                          _createTextVNode("Privacy Policy", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("button", {
                      class: "button proceed",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.submit()))
                    }, "Agree and Submit")
                  ], 32)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode($setup["LotCardWaitlist"], { estateId: $setup.estateId }, null, 8, ["estateId"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}